"use client";

import { cn } from "@/lib/utils";
import { ALPHABET } from "@/lib/lexikon";

/**
 * A–Z-Navigation des Lexikons. Aktive Buchstaben filtern die Liste,
 * inaktive (ohne Begriff) sind ausgegraut und nicht klickbar.
 */
export default function AlphabetFilter({
  active,
  available,
  onSelect,
}: {
  /** Aktuell gewählter Buchstabe oder null (= alle). */
  active: string | null;
  /** Buchstaben mit mindestens einem Begriff. */
  available: Set<string>;
  onSelect: (letter: string | null) => void;
}) {
  return (
    <nav aria-label="Alphabetische Navigation" className="flex flex-col items-center gap-3">
      <div className="flex flex-wrap justify-center gap-1.5">
        <button
          onClick={() => onSelect(null)}
          aria-pressed={active === null}
          className={cn(
            "min-w-9 h-9 px-3 inline-flex items-center justify-center rounded-lg text-sm font-semibold transition-colors cursor-pointer",
            active === null
              ? "bg-accent text-paper"
              : "bg-white border border-line text-ink-soft hover:border-accent hover:text-accent",
          )}
        >
          Alle
        </button>
        {ALPHABET.map((letter) => {
          const has = available.has(letter);
          const isActive = active === letter;
          return (
            <button
              key={letter}
              onClick={() => has && onSelect(isActive ? null : letter)}
              disabled={!has}
              aria-pressed={isActive}
              aria-label={`Begriffe mit ${letter}`}
              className={cn(
                "w-9 h-9 inline-flex items-center justify-center rounded-lg text-sm font-semibold transition-colors",
                !has && "text-ink-faint/40 cursor-not-allowed",
                has && !isActive &&
                  "bg-white border border-line text-ink-soft hover:border-accent hover:text-accent cursor-pointer",
                isActive && "bg-accent text-paper cursor-pointer",
              )}
            >
              {letter}
            </button>
          );
        })}
      </div>
    </nav>
  );
}
